export const list = [
    {
      id: "featured",
      title: "Principais"
    },
    {
      id: "web",
      title: "Websites"
    },
    {
      id: "mobile",
      title: "Mobile Apps"
    },
    {
      id: "design",
      title: "Design"
    },
    {
      id: "branding",
      title: "Outros"
    }
  ];